export const formatNumber = (num?: number) => {
  if (!num) {
    return undefined;
  } else if (num >= 1e8) {
    return (num / 1e6).toFixed(0) + "M";
  } else if (num >= 1e6) {
    return (num / 1e6).toFixed(1) + "M";
  } else if (num >= 1e5) {
    return (num / 1e3).toFixed(0) + "K";
  } else if (num >= 1e3) {
    return (num / 1e3).toFixed(1) + "K";
  } else {
    return "" + num;
  }
};
